import React, { Fragment, useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import { MoreVert } from "iconoir-react";
import moment from "moment";
import "moment/locale/vi";
import NotiTag from "../../components/NotiTag";
import SkeletonNotification from "./../../components/Skeleton/SkeletonNotification";
import { NOTIFICATION_STATUS } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spin } from "antd";
import { StatusTag } from "./../../components/common/StatusTag";
import { TYPE_STATUS } from "../../constants";

const NotificationSystem = ({ notificationStore }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [isFilterUnread] = useState(false);
  //   const [isLoadingNotification, setIsLoadingNotification] = useState(false)
  let only_news_notification = false;

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        notificationStore.clearStore();
        await Promise.all([
          notificationStore.getCurrentUserNotification(only_news_notification),
        ]);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let notificationList = toJS(notificationStore.notificationList);
  // console.log("check", notificationList);
  // const getParameterByName = (name, url = window.location.href) => {
  //     name = name.replace(/[\[\]]/g, '\\$&')
  //     let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
  //         results = regex.exec(url)
  //     if (!results) return null
  //     if (!results[2]) return ''
  //     return decodeURIComponent(results[2].replace(/\+/g, ' '))
  // };
  // const onlyNewsNotificationParams = getParameterByName(
  //     'only_news_notification'
  // )

  /** Xử lý đã đọc thông báo */
  const handleReadNotify = useCallback(
    (id, status, num) => {
      if (status && num === 0) {
        // message.warning('Thông báo đã được đọc!')
        return;
      }
      if (status) return;
      //   setIsLoadingNotification(true)
      notificationStore.readNotification(id).then(() => {
        if (isFilterUnread) {
          const itemsList = items.filter((el) => el.id !== id);
          setItems(itemsList);
        } else {
          const itemsList = [...items];
          const indexReadItem = items.findIndex((item) => item.id === id);
          const itemReplace = {
            ...items[indexReadItem],
            status: true,
          };
          itemsList.splice(indexReadItem, 1, itemReplace);
          setItems([...itemsList]);
        }
        // if (onlyNewsNotificationParams === 'false') {
        //     notificationStore.setUnreadNotificationCount('remove')
        // } else {
        //     notificationStore.setUnreadNewsCount('remove')
        // }
        // message.success('Thông báo được đánh dấu đã đọc!')
      });
      // .finally(() => setIsLoadingNotification(false))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [items]
  );

  // const goToContentNotification = async (type, id) => {
  //   console.log(type);
  //   if (type.slice(0, 5) === "OTHER") {
  //     switch (type.slice(0, 5)) {
  //       case "OTHER":
  //         return navigate(`/proposal/view/${id}`);
  //       default:
  //         return;
  //     }
  //   } else {
  //     switch (type) {
  //       case NOTIFICATION_STATUS.MEETING:
  //         return navigate(`/proposal/view/${id}`);
  //       case NOTIFICATION_STATUS.PROPOSAL_SALARY:
  //         return navigate(`/proposal/view/${id}`);
  //       case NOTIFICATION_STATUS.OUTGOING:
  //         return navigate(`/internal-document/outgoing-document/view/${id}`);
  //       case NOTIFICATION_STATUS.INCOMING:
  //         return navigate(`/internal-document/incoming-document/view/${id}`);
  //       case NOTIFICATION_STATUS.WORK:
  //         return navigate(`/work/view/${id}`);
  //       case NOTIFICATION_STATUS.TASK:
  //         return navigate(`/mission/view/${id}`);
  //       case NOTIFICATION_STATUS.WORK_SCHEDULE:
  //         return navigate(`/company-work-schedule/view/${id}`);
  //       default:
  //         return;
  //     }
  //   }
  // };
  const goToContentNotification = async (type, id) => {
    if (type.slice(0, 5) === "OTHER") {
      switch (type.slice(0, 5)) {
        case "OTHER":
          return navigate(`/proposal/view/${id}`);
        default:
          return;
      }
    } else {
      switch (type) {
        case NOTIFICATION_STATUS.OUTGOING:
          return navigate(`/internal-document/outgoing-document/view/${id}`);
        case NOTIFICATION_STATUS.INCOMING:
          return navigate(`/internal-document/incoming-document/view/${id}`);
        // case NOTIFICATION_STATUS.VBLT_DI:
        //   return navigate(`/connected-document/outgoing-document/view/${id}`);
        // case NOTIFICATION_STATUS.VBLT_DEN:
        //   return navigate(`/connected-document/incoming-document/view/${id}`);
        case NOTIFICATION_STATUS.WORK:
          return navigate(`/work/view/${id}`);
        case NOTIFICATION_STATUS.TASK:
          return navigate(`/mission/view/${id}`);
        case NOTIFICATION_STATUS.VEHICLE:
        case NOTIFICATION_STATUS.LEAVE:
        case NOTIFICATION_STATUS.LEAVE_ANNUAL:
        case NOTIFICATION_STATUS.LEAVE_ABNORMAL:
        case NOTIFICATION_STATUS.LEAVE_NO_SALARY:
        case NOTIFICATION_STATUS.SICK:
        case NOTIFICATION_STATUS.SICK_OTHER:
        case NOTIFICATION_STATUS.OVERTIME_NORMAL:
        case NOTIFICATION_STATUS.OVERTIME_DAYOFF:
        case NOTIFICATION_STATUS.OVERTIME_HOLIDAY:
        case NOTIFICATION_STATUS.OVERTIME_CHAIRMAN:
        case NOTIFICATION_STATUS.BUSINESS_TRIP:
        case NOTIFICATION_STATUS.EVALUATE_MEMBER:
        case NOTIFICATION_STATUS.EVALUATE_LEADER:
        case NOTIFICATION_STATUS.TIMEKEEPER:
        case NOTIFICATION_STATUS.STATIONERY:
        // case NOTIFICATION_STATUS.RETIMEKEEPING:
        case NOTIFICATION_STATUS.MEETING:
          return navigate(`/proposal/view/${id}`);
        case NOTIFICATION_STATUS.PROPOSAL_SALARY:
          return navigate(`/proposal/view/${id}`);
        case NOTIFICATION_STATUS.CONSULT:
          return navigate(`/administrative/consult/view/${id}`);
        case NOTIFICATION_STATUS.POLICY:
          return navigate(`/administrative/policy/view/${id}`);
        case NOTIFICATION_STATUS.WORK_SCHEDULE:
          return navigate(`/company-work-schedule/view/${id}`);
        case NOTIFICATION_STATUS.GENERAL:
          return navigate(`/utility/general-notifications/view/${id}`);
        case NOTIFICATION_STATUS.NEWS:
          return navigate(`/utility/general-notifications/view/${id}`);
        //phân biệt tin nhắn đến/đi
        case NOTIFICATION_STATUS.INTERNAL_MESSAGE_INCOMING:
        case NOTIFICATION_STATUS.INTERNAL_MESSAGE_INCOMING_REPLY:
        // loadingAnimationStore.showSpinner(true);
        // let internal_message_user_code =
        //   await internalMessageStore.getInternalMessageUserCodeByInternalMessageCode(
        //     id
        //   );
        // loadingAnimationStore.showSpinner(false);
        // return navigate(
        //   `/utility/internal-message/receive/view/${internal_message_user_code}`
        // );
        case NOTIFICATION_STATUS.INTERNAL_MESSAGE_OUTGOING:
        case NOTIFICATION_STATUS.INTERNAL_MESSAGE_OUTGOING_REPLY:
        // return navigate(`/utility/internal-message/send/view/${id}`);
        default:
          return;
      }
    }
  };
  const [hasMore, setHasMore] = useState(false);
  const fetchMoreData = async () => {
    if (
      notificationList.length >= notificationStore.notificationListTotalCount
    ) {
      setHasMore(false);
      return;
    } else {
      setHasMore(true);
    }

    notificationStore.notificationListPageIndex =
      notificationStore.notificationListPageIndex + 1;

    try {
      await notificationStore.getCurrentUserNotification(
        only_news_notification
      );
    } catch (err) {
      console.log(err);
    } finally {
      setHasMore(false);
    }
  };

  return (
    <div className="custom-pagination">
      {loading ? (
        <SkeletonNotification />
      ) : (
        <Fragment>
          <InfiniteScroll
            dataLength={notificationList.length}
            next={fetchMoreData}
            hasMore={hasMore}
            style={{
              scrollSnapStop: "always",
            }}
            scrollableTarget="infinityScrollableDiv"
            loader={
              <div
                style={{
                  paddingTop: 20,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {hasMore ? <Spin tip="Đang tải..." /> : ""}
              </div>
            }
          >
            <div>
              {notificationList?.map((item) => {
                return (
                  <div
                    className="relative bg-[#F8F8F8] rounded-lg p-3.5 mt-5"
                    onClick={() => {
                      handleReadNotify(item.id, item.status, 1);
                      goToContentNotification(item.type, item.code);
                    }}
                  >
                    {item.status === false ? (
                      <div className="absolute right-2 top-2 w-2 h-2 bg-[#0073C7] rounded-full" />
                    ) : (
                      ""
                    )}
                    {item.status === false ? (
                      <div
                        className="font-bold text-sm"
                        dangerouslySetInnerHTML={{ __html: item.content }}
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          width: "100%",
                          lineHeight: "25px",
                          WebkitLineClamp: "2",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          maxHeight: "50px",
                        }}
                      />
                    ) : (
                      <div
                        className="text-sm"
                        dangerouslySetInnerHTML={{ __html: item.content }}
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          width: "100%",
                          lineHeight: "25px",
                          WebkitLineClamp: "2",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          maxHeight: "50px",
                        }}
                      />
                    )}
                    <div className="flex justify-between">
                      <div className="text-xs mr-1">
                        {moment(item.time_created).format("dddd", "vi")},{" "}
                        {moment(item.time_created).format("L")} lúc{" "}
                        {moment(item.time_created).format("LT", "vi")}
                      </div>
                    </div>

                    <div className="text-xs font-[600] mt-1">
                      bởi {item.owner}
                    </div>
                    <div className="flex justify-between  mt-1">
                      {/* <NotiTag type={item.type} /> */}
                      <div>
                        {StatusTag(TYPE_STATUS.NOTIFICATION, item.type)}
                      </div>
                      <div>
                        <MoreVert />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </InfiniteScroll>
        </Fragment>
      )}
    </div>
  );
};

export default inject("notificationStore")(observer(NotificationSystem));
